import PropTypes from 'prop-types'
import React from 'react'
import { Button } from 'reactstrap'
import { Form, Formik } from 'formik'
import AdminSelectSearchField from 'domains/admin/admin-select-search-field'
import * as Yup from 'yup'

const propTypes = {
  onSubmitForm: PropTypes.func.isRequired
}

const validationSchema = Yup.object().shape({
  admin: Yup.object().required('Cannot be blank')
})

/**
 * @param {Function} onSubmitForm
 */
const CustomerOrderSalesAdminForm     = ({
  onSubmitForm
}) => (
  <>
    <Formik
      initialValues={{ admin: '' }}
      validationSchema={ validationSchema }
      onSubmit={ onSubmitForm }
    >
      {
        (formikBag) => (
          <Form>
            <AdminSelectSearchField
              name='admin'
              label='admin'
              required={ true }
            />
            <Button
              className='float-right'
              color='success'
              type='submit'
              disabled={ formikBag.isSubmitting }
            >
              { 'Submit' }
            </Button>

          </Form>
        )
      }
    </Formik>

  </>
)
CustomerOrderSalesAdminForm.propTypes = propTypes

export default CustomerOrderSalesAdminForm